/**
 * The reschedule page in the admin (PLAN-GENERICITE.md § 4 quinquies, step 4): the setting
 * `appointments.reschedule_url` (Settings › Rendez-vous, returned by get_appointments_settings()), the
 * page the clients' mails link to (`supabase/functions/_shared/rescheduleLink.ts`), then the front's
 * platform default `VITE_RESCHEDULE_BASE_URL`; neither: no link. No address written in the code.
 */

/** The page's address, without a trailing slash; null when none is configured. Pure. */
export function rescheduleBaseOf(setting: string | null | undefined, platformDefault: string | null | undefined): string | null {
  const base = setting?.trim() || platformDefault?.trim() || '';
  return base.replace(/\/+$/, '') || null;
}

/** The reschedule link of a token, `<page>/<token>`; null without a page or a token. Pure. */
export function rescheduleUrlOf(base: string | null, token: string | null | undefined): string | null {
  return base && token ? `${base}/${token}` : null;
}
